import { render, staticRenderFns } from "./DailyLastRevisions.vue?vue&type=template&id=9d7e01a2&scoped=true"
import script from "./DailyLastRevisions.vue?vue&type=script&lang=js"
export * from "./DailyLastRevisions.vue?vue&type=script&lang=js"
import style0 from "./DailyLastRevisions.vue?vue&type=style&index=0&id=9d7e01a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7e01a2",
  null
  
)

export default component.exports